angular.module("UI8.controllers").controller("SessionController", [
  "$scope",
  "$http",
  "$window",
  "$timeout",
  function ($scope, $http, $window, $timeout) {
    $scope.account = {};
    $scope.loading = false;
    $scope.loginError = null;

    function parseQuery(search) {
      var pairs = search.substring(1).split("&");
      var obj = {};
      for (var i in pairs) {
        if (pairs[i] === "") continue;
        var pair = pairs[i].split("=");
        obj[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
      }
      return obj;
    }

    var query = parseQuery(window.location.search);
    if (query.email) $scope.account.email = query.email;
    $scope.next = query.from || "";

    $scope.backToLogin = function () {
      $scope.account.twoFactor = false;
      $scope.account.code = "";
      $scope.loginError = null;
    };

    $scope.submitLogin = function () {
      if ($scope.loading) return;
      $scope.loginError = null;

      if ($scope.account.twoFactor) {
        return submitCode();
      }

      submitCredentials();
    };

    function submitCode() {
      var code = ($scope.account.code || "").trim();
      if (!code) {
        $scope.loginError = "Please enter your authentication code.";
        return;
      }

      $scope.loading = true;
      $http.post("/account/signin?json=1", { code: code }).then(
        function (response) {
          $scope.loading = false;
          if (response.data.error) {
            $scope.loginError = response.data.error;
            return;
          }
          $window.location.replace(response.data.redirect_to || "/");
        },
        function () {
          $scope.loading = false;
          $scope.loginError = "Unable to login. Please try again.";
        }
      );
    }

    function submitCredentials() {
      var rc = window.grecaptcha;
      var rcKey = UI8.recaptchaSiteKey;
      if (!rc || !rcKey) {
        $scope.loginError = "Unable to process login. Please try again later.";
        return;
      }

      $scope.loading = true;
      var rcPromise;
      try {
        rcPromise = rc.execute(rcKey, { action: "login" });
      } catch (e) {
        $scope.loading = false;
        $scope.loginError =
          "Login couldn't start — reCAPTCHA appears to be blocked. Please disable your content blocker for ui8.net and try again.";
        return;
      }
      rcPromise
        .then(function (token) {
          $http
            .post("/account/signin?json=1", {
              email: $scope.account.email,
              password: $scope.account.password,
              next: $scope.next,
              rcToken: token,
            })
            .then(
              function (response) {
                $scope.loading = false;
                if (response.data.error) {
                  $scope.loginError = response.data.error;
                  return;
                }
                if (response.data.twoFactor) {
                  $scope.account.twoFactor = true;
                  $timeout(function () {
                    var input = document.querySelector('[name="code"]');
                    if (input) input.focus();
                  });
                  return;
                }
                $window.location.replace(response.data.redirect_to || "/");
              },
              function () {
                $scope.loading = false;
                $scope.loginError = "Unable to login. Please try again.";
              }
            );
        })
        .catch(function () {
          $scope.loading = false;
          $scope.$apply(function () {
            $scope.loginError =
              "Unable to process login. Please try again later.";
          });
        });
    }
  },
]);
